import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'antd'
import './../../ui.style.scss'
import { utilityService } from '../../../../services/UtilityService'

const Option = Select.Option

const filterGenre = (input, option, options) => {
  const currentOption = options.find(item => item.id === option.props.value)
  const returnValue = currentOption.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
  return returnValue
}

const GenreDropDown = ({ onOptionSelect, displayParam, keyParam, options, placeHolder, className, allowClear, defaultValue, selectedValue, parent, ...props }) => {
  const value = selectedValue && selectedValue.length ? (selectedValue || []).map(value => value.id) : []
  const genreSelect = (selectedValue) => {
    const selectedGenres = options.filter(item => selectedValue.includes(item.id))
    onOptionSelect(selectedGenres)
  }

  return (
    <Select
      className={className ? 'multi-drop-down ' + className : 'multi-drop-down'}
      mode='multiple'
      allowClear={allowClear}
      defaultValue={defaultValue}
      style={{ width: '100%' }}
      placeholder={placeHolder}
      value={value}
      getPopupContainer={() => document.getElementById(parent)}
      onChange={genreSelect}
      filterOption={(input, option) => filterGenre(input, option, options)}
      optionLabelProp='label'
      {...props}
    >
      {(options || []).map((option, index) => <Option label={option[displayParam]} key={option.id} value={option[keyParam]}>{option[displayParam]} <span>{utilityService.getSourceDetails(option['source'])}</span> </Option>)}
    </Select>
  )
}

GenreDropDown.propTypes = {
  /** Options of Dropdown. */
  options: PropTypes.array.isRequired,
  /** Option selection action of Dropdown. */
  onOptionSelect: PropTypes.func,
  /** Placeholder text of Dropdown. */
  placeHolder: PropTypes.string,
  /** Class name */
  className: PropTypes.string,
  /** default values */
  defaultValue: PropTypes.array
}

GenreDropDown.defaultProps = {
  placeHolder: 'Select'
}

export default GenreDropDown
